import { ApprovalProcess, ApprovalStatusEnum, RightEnum } from "@finway-group/shared/lib/models"
import React from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

import { AuthzService } from "Shared/services"

import { ApprovalProcessIndicatorTag } from "../../../../../components/approvalProcessesIndicator"
import { useWorkflowById } from "../../../../../shared/hooks/workflow.hooks"

interface WorkflowFieldProps {
    approvalProcesses: Array<ApprovalProcess>
}

export const WorkflowField = ({ approvalProcesses }: WorkflowFieldProps) => {
    const { t } = useTranslation()

    const currentApprovalProcess =
        approvalProcesses.find((approvalProcess) => approvalProcess.status === ApprovalStatusEnum.IN_PROGRESS) ||
        approvalProcesses.find((approvalProcess) => approvalProcess.status === ApprovalStatusEnum.NOT_STARTED)
    const workflowId = currentApprovalProcess?.workflow
    const workflow = useWorkflowById(workflowId)

    if (!workflow) {
        return null
    }
    return (
        <li>
            <span className="title">{t("label:workflow.workflow")}</span>
            <div className="flex gap-10">
                <div className="truncate xl:max-w-160 max-w-100" data-testid="finway:WorkflowField:name">
                    {AuthzService.isRightGrantedForLoggedInUser(RightEnum.WORKFLOW__ALL__READ) ? (
                        <Link to={`/workflows/${workflow?._id}`}>{workflow?.name}</Link>
                    ) : (
                        <span className="text-text">{workflow?.name}</span>
                    )}
                </div>
                <ApprovalProcessIndicatorTag scope={currentApprovalProcess?.scope} approvalProcesses={approvalProcesses} />
            </div>
        </li>
    )
}
